import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

// import Model, { userFetchModel as model } from './model';

import ItemFetchFactory from './itemFetchFactory';

// import ItemComponent from './ItemComponent';

// import consts from './consts';

const ItemFac = {
  users: new ItemFetchFactory('users'),
  userGroups: new ItemFetchFactory('userGroups'),
  companies: new ItemFetchFactory('companies')
};

/* const model = {
  users: new Model('users'),
  userGroups: new Model('userGroups')
}; */

const getItemInfo = (itemType = 'users', itemId, fieldName, itemUpdatedCallback, defaultValue) => {
  const factory = ItemFac[itemType];

  const response = factory.fetchItemForId(itemId, itemUpdatedCallback, true, fieldName);
  if (typeof response === 'string' && response === 'loading') {
    return defaultValue || response;
  }
  return response;
};

@observer
class ItemFetch extends React.Component {
  constructor(props) {
    super(props);

    // this.model = model[props.itemType];
    // this.items = this.model[props.itemType];
    this.fac = ItemFac[props.itemType];
    this.state.item = this.getItem(props.itemId);
  }

  state = {};

  UNSAFE_componentWillReceiveProps(nextProps) {
    // if (nextProps.itemType !== '')
    if (nextProps.itemId !== this.props.itemId) {
      this.fac = ItemFac[nextProps.itemType];
      this.state.item = this.getItem(nextProps.itemId);
    }
  }

  getItem = itemId => this.fetchForItemId(itemId, this.itemUpdatedCallback);

  itemUpdatedCallback = (itemData) => {
    this.setState({
      item: itemData
    });
  };

  fetchForItemId = (itemId, itemUpdatedCallback) => this.fac.fetchItemForId(itemId, itemUpdatedCallback);

  render() {
    const { itemId, loader, notFound, renderer } = this.props;

    const item = this.state.item;
    if (!item || item.loading === true) {
      return loader;
    }

    if (item && item.notFound === true) {
      return notFound;
    }

    return renderer(item);
  }
}

ItemFetch.defaultProps = {
  renderer: item => <span>{item.name}</span>,
  loader: <span>.....</span>,
  notFound: <span>item not found...</span>,
  itemType: 'users'
};

ItemFetch.propTypes = {
  itemId: PropTypes.string.isRequired,
  renderer: PropTypes.func,
  loader: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
  notFound: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
  itemType: PropTypes.oneOf(['users', 'userGroups', 'companies'])
};

export { ItemFetch, getItemInfo };
export default ItemFetch;
